module.exports = __webpack_public_path__ + "img/e_3_17_g.beb9a06b.png";